"use strict";

define('view/setting/application.settings',['require','exports','module','uikit/uikit','langs','semantic/modules/sticky'],function (require, exports, module) {
  var UIKit = require('uikit/uikit');
  var langs = require('langs');
  require('semantic/modules/sticky');
  var MenuItemSegment = UIKit.SegmentList.Segment.extend({
    attributes: {
      role: 'menuitem'
    }
  });
  var ApplicationSettingsView = UIKit.Container.extend({
    options: {
      fieldGroupCount: 2,
      stickyTopOffset: 150
    },
    bindings: {
      subSection: 'subSection'
    },
    initialize: function initialize() {
      UIKit.Container.prototype.initialize.apply(this, arguments);
      this.saveButton = new UIKit.Button({
        text: 'Save',
        icon: 'save',
        color: 'primary',
        floated: 'right'
      });
      this.pageHeader = new UIKit.Header({
        tagName: 'h2',
        className: UIKit.Header.prototype.className + ' accessibility-text',
        text: langs.phrase('Application.Settings.Title')
      });
      this.sectionHeader = new UIKit.Header({
        tagName: 'h3',
        attributes: {
          style: 'line-height: 2em; margin: 0;'
        }
      });
      this.grid = new UIKit.Grid({
        className: UIKit.Grid.prototype.className + ' application-settings-container'
      });
      this.sidebar = new UIKit.SegmentList({
        tagName: 'nav',
        childView: MenuItemSegment,
        attributes: {
          'aria-label': langs.phrase('Application.Settings.Navigation.ARIALabel')
        },
        className: 'ui sticky',
        selectable: true
      });
      this.topSection = new UIKit.Container({
        className: 'ui blue segment sticky'
      });
      this.rightSide = new UIKit.Container({
        attributes: {
          id: 'applicationSettingsDetails'
        }
      });
      this.sectionHeader.$el.css({
        'float': 'left'
      });
      this.proxyEventsFrom(this.saveButton, {
        withPrefix: 'save'
      });
      this.proxyEventsFrom(this.sidebar, {
        withPrefix: 'sidebar'
      });
      this.topSection.add(this.sectionHeader).add(this.saveButton);
      this.rightSide.add(this.topSection);
      this.grid.add(this.pageHeader, {
        wide: 'sixteen'
      }).add(this.sidebar, {
        wide: 'five'
      }).add(this.rightSide, {
        wide: 'eleven'
      });
      this.add(this.grid);
      this.formElementBindings = {};
      this.formFieldBindings = {};
    },
    onFirstRender: function onFirstRender() {
      this.configureCollectionEvents();
      this.injectFormElements();
      this.on('inject:form', _.debounce(function () {
        this.sidebar.$el.sticky({
          offset: this.stickyTopOffset,
          context: 'body'
        });
      }));
    },
    refreshSticky: function refreshSticky() {
      this.sidebar.$el.sticky('refresh');
      return this;
    },
    configureCollectionEvents: function configureCollectionEvents() {
      if (!this.collection) {
        return;
      }
      this.listenTo(this.collection, 'add remove reset sort', _.debounce(this.injectFormElements));
    },
    injectFormElements: function injectFormElements() {
      var form, fieldGroup;
      this.forms = [];
      if (!this.collection) {
        return;
      }
      this.rightSide.removeView(this.topSection);
      this.rightSide.removeAll({
        destroy: true
      });
      this.rightSide.add(this.topSection);
      function checkFieldGroup() {
        if (form && fieldGroup && fieldGroup.count() === 1) {
          form.add(fieldGroup.at(0));
          fieldGroup.removeAll();
          fieldGroup.destroy();
        }
      }
      this.collection.each(function (model) {
        var subSection = model.get(this.bindings.subSection);
        fieldView = this.buildFormFieldView(model);
        if (!fieldView) {
          return;
        }
        if (!form || form.subSection != subSection) {
          form = this.buildFormSection(subSection);
          this.forms.push(form);
          form.subSection = subSection;
          this.rightSide.add(new UIKit.Container({
            className: 'ui segment'
          }).add(form));
          checkFieldGroup();
          fieldGroup = null;
        }
        if (!fieldGroup || fieldGroup.count() == this.fieldGroupCount) {
          fieldGroup = new UIKit.Form.FieldGroup({});
          form.add(fieldGroup);
        }
        fieldGroup.add(fieldView);
      }, this);
      checkFieldGroup();
      this.trigger('inject:form');
    },
    buildFormSection: function buildFormSection(section) {
      var form = new UIKit.Form({
        model: this.collection
      });
      if (section) {
        form.add(new UIKit.Header({
          tagName: 'h4',
          text: section
        }));
      }
      return form;
    },
    buildFormFieldView: function buildFormFieldView(model) {
      var View = this.getSettingView(model),
        fieldView = null,
        formElementView = null;
      if (!View) {
        return;
      }
      formElementView = this.buildFormElementView(View, model);
      fieldView = new UIKit.Form.Field({
        model: model,
        bindings: _.clone(this.formFieldBindings)
      }).add(formElementView);
      return fieldView;
    },
    getSettingView: function getSettingView(model) {
      switch (model.get('type')) {
        case 'Integer':
          return UIKit.InputCounter;
        case 'String':
        case 'Email':
          return UIKit.Input;
        case 'Boolean':
          return UIKit.Checkbox;
        case 'List':
        case 'FiscalYearEndMonth':
          return UIKit.Dropdown;
      }
    },
    buildFormElementView: function buildFormElementView(View, model) {
      var options = {
        model: model,
        bindings: _.clone(this.formElementBindings)
      };
      var childOptions = Mn._getValue(this.getOption('formElementOptions'), this, [model]);
      return new View(_.extend(options, childOptions));
    }
  });
  module.exports = ApplicationSettingsView;
});

